"use strict";
// (C) 2007-2021 GoodData Corporation
exports.__esModule = true;
exports.DEFAULT_LEGEND_CONFIG = exports.SupportedLegendPositions = exports.LegendPosition = void 0;
/**
 * @internal
 */
exports.LegendPosition = {
    LEFT: "left",
    RIGHT: "right",
    TOP: "top",
    BOTTOM: "bottom",
    AUTO: "auto"
};
/**
 * @internal
 */
exports.SupportedLegendPositions = ["left", "right", "top", "bottom"];
/**
 * @internal
 */
exports.DEFAULT_LEGEND_CONFIG = {
    enabled: true,
    position: exports.LegendPosition.TOP
};
//# sourceMappingURL=types.js.map